import api from './api';

export const cenowkiSettingsService = {
  /**
   * Pobierz ustawienia cenówek dla użytkownika
   */
  async getSettings(user = 'default') {
    try {
      const response = await api.get('cenowki-settings', { params: { user } });
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania ustawień cenówek:', error);
      return { success: false, data: null };
    }
  },

  /**
   * Zapisz ustawienia cenówek dla użytkownika
   */
  async saveSettings(user = 'default', settings) {
    try {
      const response = await api.post('cenowki-settings', { user, settings });
      return response.data;
    } catch (error) {
      console.error('Błąd zapisywania ustawień cenówek:', error);
      return { success: false };
    }
  }
};

export default cenowkiSettingsService;
